/* =====================================================================
   v2 — Yardım Merkezi
   Makaleler sunucu tarafında basılıdır; burada yalnızca gösterilip gizlenir.
   - Kategori kartına basınca o kategorinin paneli açılır (tab davranışı)
   - Arama tüm panellerde aynı anda filtreler, eşleşmeyen paneli gizler
   JS yüklenmezse: ilk kategori açık kalır, arama kutusu hiç görünmez.
   ===================================================================== */
(function () {
  var reduced =
    (window.V2 && window.V2.reduced) ||
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function slice(list) {
    return Array.prototype.slice.call(list);
  }

  /* Türkçe'ye duyarlı, aksan bağışlayan normalleştirme. Hem aranan metne hem
     makale terimlerine AYNI fonksiyon uygulanır — Liquid'in downcase'i ile
     tarayıcının toLowerCase'i Türkçe'de aynı sonucu vermediği için eşleştirme
     tamamen burada yapılır. Böylece "isik" yazan "Işık"ı da bulur. */
  var FOLD_FROM = 'ıİIğĞüÜşŞöÖçÇâÂîÎûÛ';
  var FOLD_TO = 'iiigguussooccaaiiuu';

  function fold(text) {
    var out = String(text).replace(/[ıİIğĞüÜşŞöÖçÇâÂîÎûÛ]/g, function (ch) {
      return FOLD_TO.charAt(FOLD_FROM.indexOf(ch));
    });
    return out.toLowerCase().trim();
  }

  function setup(sec) {
    if (!sec || sec.dataset.v2HcBound === 'true') return;
    sec.dataset.v2HcBound = 'true';

    var tabs = slice(sec.querySelectorAll('[data-v2-hc-cat]'));
    var panels = slice(sec.querySelectorAll('[data-v2-hc-panel]'));
    var arts = slice(sec.querySelectorAll('[data-v2-hc-art]'));

    /* Arama dizini bir kez kurulur: her makalenin başlık + özeti katlanmış hâlde */
    arts.forEach(function (art) {
      art.v2HcIndex = fold(art.dataset.v2HcTerms || '');
    });
    var box = sec.querySelector('[data-v2-hc-search]');
    var input = sec.querySelector('[data-v2-hc-input]');
    var clear = sec.querySelector('[data-v2-hc-clear]');
    var summary = sec.querySelector('[data-v2-hc-summary]');
    var noresult = sec.querySelector('[data-v2-hc-noresult]');

    /* Arama yalnızca JS varken anlamlı — sunucu gizli basar, burada açılır. */
    if (box) box.hidden = false;

    /* ---------- Kategori seçimi ---------- */
    function selectCategory(handle, focusPanel) {
      tabs.forEach(function (tab) {
        tab.setAttribute('aria-selected', tab.dataset.v2HcCat === handle ? 'true' : 'false');
      });
      panels.forEach(function (panel) {
        panel.hidden = panel.dataset.v2HcPanel !== handle;
      });
      if (!focusPanel) return;
      var open = sec.querySelector('[data-v2-hc-panel="' + handle + '"]');
      if (!open) return;
      /* Mobilde kart şeridi listeyi ekrandan itiyor; listeye kaydır. */
      if (window.innerWidth < 640) {
        open.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' });
      }
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        if (input && input.value) resetSearch();
        selectCategory(tab.dataset.v2HcCat, true);
      });
    });

    /* Ok tuşlarıyla sekmeler arasında gezinme */
    tabs.forEach(function (tab, index) {
      tab.addEventListener('keydown', function (event) {
        var step = event.key === 'ArrowRight' ? 1 : event.key === 'ArrowLeft' ? -1 : 0;
        if (!step) return;
        event.preventDefault();
        var next = tabs[(index + step + tabs.length) % tabs.length];
        next.focus();
        next.click();
      });
    });

    /* ---------- Arama ---------- */
    function resetSearch() {
      if (input) input.value = '';
      if (clear) clear.hidden = true;
      if (summary) summary.hidden = true;
      if (noresult) noresult.hidden = true;
      sec.classList.remove('is-searching');
      arts.forEach(function (art) {
        art.hidden = false;
        /* katlanır kip: arama açtıysa geri kapat */
        var fold = art.querySelector('[data-v2-hc-fold]');
        if (fold && fold.dataset.v2HcAutoOpen === 'true') {
          fold.open = false;
          delete fold.dataset.v2HcAutoOpen;
        }
      });
      var active = tabs.filter(function (t) {
        return t.getAttribute('aria-selected') === 'true';
      })[0];
      selectCategory(active ? active.dataset.v2HcCat : panels[0] && panels[0].dataset.v2HcPanel, false);
    }

    function runSearch() {
      var query = fold(input.value);
      if (clear) clear.hidden = query === '';

      if (query === '') {
        resetSearch();
        return;
      }

      sec.classList.add('is-searching');

      var hits = 0;
      arts.forEach(function (art) {
        var match = art.v2HcIndex.indexOf(query) !== -1;
        art.hidden = !match;
        if (match) hits += 1;

        /* Katlanır kipte eşleşme açıklamada olabilir — kapalıyken kullanıcı
           neden eşleştiğini göremez, o yüzden açıp işaretliyoruz. */
        var fold = art.querySelector('[data-v2-hc-fold]');
        if (fold && match && !fold.open) {
          fold.open = true;
          fold.dataset.v2HcAutoOpen = 'true';
        }
      });

      /* Eşleşme taşıyan panel açık kalır, boş panel gizlenir. */
      panels.forEach(function (panel) {
        var any = slice(panel.querySelectorAll('[data-v2-hc-art]')).some(function (art) {
          return !art.hidden;
        });
        panel.hidden = !any;
      });

      if (summary) {
        /* Şablon '__n__' yer tutucusuyla gelir: bkz. locales v2.help.results_count */
        var template = summary.dataset.v2HcSummary || '';
        summary.textContent = template.replace('__n__', hits);
        summary.hidden = template === '';
      }
      if (noresult) noresult.hidden = hits !== 0;
    }

    /* Ana sayfadaki özet karttan gelinmişse (?hc=<handle>) o kategoriyi aç. */
    var wanted = (location.search.match(/[?&]hc=([^&#]+)/) || [])[1];
    if (wanted) {
      wanted = decodeURIComponent(wanted);
      var exists = tabs.some(function (tab) {
        return tab.dataset.v2HcCat === wanted;
      });
      if (exists) selectCategory(wanted, true);
    }

    if (input) {
      input.addEventListener('input', runSearch);
      input.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') resetSearch();
      });
    }
    if (clear) {
      clear.addEventListener('click', function () {
        resetSearch();
        if (input) input.focus();
      });
    }
  }

  function init(root) {
    var scope = root || document;
    if (scope.matches && scope.matches('[data-v2-hc]')) setup(scope);
    slice(scope.querySelectorAll('[data-v2-hc]')).forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
